module.exports = require('./dist/ingresse-sdk');
